import { render, staticRenderFns } from "./WorkFlowTicket.vue?vue&type=template&id=2dbd4932&scoped=true"
import script from "./WorkFlowTicket.vue?vue&type=script&lang=js"
export * from "./WorkFlowTicket.vue?vue&type=script&lang=js"
import style0 from "./WorkFlowTicket.vue?vue&type=style&index=0&id=2dbd4932&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbd4932",
  null
  
)

export default component.exports